export const dummyStats = Object.freeze({})
